/*
 * COPYRIGHT:     Copyright © 2018 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part,
 *                is prohibited.
 */

export const LABEL_EXCLUSIVE_OFFERS = 'Exclusive Offers'
export const LABEL_EXCLUSIVE_OFFERS_ACTIVITIES = 'Exclusive Offer Activities'
export const LABEL_ACTIVITIES = 'Activities'
export const LABEL_EXCLUDED_ACTIVITIES = 'Excluded'
